import { AppExceptionResponseData } from '../../../hooks/useHandleAppException';
import { ProductPageDTO } from '../../../modules/products/ProductTypes';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import {
  BindProductCategoryParams,
  FindProductCategoryOutput,
  FindProductsPageParams,
  GetSuggestedProducts,
  GetSuggestedProductsResponse,
} from './products.types';

const PATH = 'products';

export const findSuggestedProductColors = (params: GetSuggestedProducts) =>
  restApi.get<GetSuggestedProductsResponse>(`${PATH}/suggested`, params);

export const findProductsPage = (params: FindProductsPageParams, signal?: AbortSignal) =>
  restApi.get<ProductPageDTO[]>(`${PATH}/page`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const findProductsCount = (
  params: Omit<FindProductsPageParams, 'skip' | 'limit'>,
  signal?: AbortSignal,
) =>
  restApi.get<number>(`${PATH}/count`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const findProductCategory = (productId: string, signal?: AbortSignal) =>
  restApi.get<FindProductCategoryOutput | null>(`${PATH}/${productId}/category`, undefined, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const bindProductCategory = ({ productId, categoryId }: BindProductCategoryParams) =>
  restApi.post<void, AppExceptionResponseData>(`${PATH}/${productId}/categories/${categoryId}`);

export const unbindProductCategory = (productId: string) =>
  restApi.delete<void, AppExceptionResponseData>(`${PATH}/${productId}/category`);
